import type { CoachProfile } from '@efdigital/ll-addon-data';
import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coachee/session-card.gts';
import type { CoachingCoacheeCohortSessionsActionRequiredModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/sessions/action-required';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortSessionsActionRequiredSignature {
  Args: {
    model: CoachingCoacheeCohortSessionsActionRequiredModel;
    controller: unknown;
  };
}

function lookupCoach(
  coachUserId: string,
  coaches: CoachProfile[]
): CoachProfile | undefined {
  return coaches.find((coach) => coach.user === coachUserId);
}

export default class CoachingCoacheeCohortSessionsActionRequired extends Component<CoachingCoacheeCohortSessionsActionRequiredSignature> {
  @service declare router: RouterService;

  get hasSessions(): boolean {
    return this.args.model.actionRequired.length > 0;
  }

  refresh = () => {
    this.router.refresh('coaching.coachee.cohort.sessions');
  };

  <template>
    {{pageTitle "Sessions"}}

    <div class={{PAGE_WRAPPER_CONTENT}}>
      {{! Sessions awaiting the coach's confirmation are deliberately absent:
          there is nothing for the coachee to do about one, and they already
          appear under Upcoming, which the index route merges them into. }}
      {{#if this.hasSessions}}
        {{#if @model.actionRequired.length}}
          <div class="d-flex flex-column gap-4">
            {{#each @model.actionRequired as |session|}}
              {{#let
                (lookupCoach session.coachUserId @model.coaches)
                as |coach|
              }}
                {{#if coach}}
                  <SessionCard
                    @session={{session}}
                    @coach={{coach}}
                    @coachingConfig={{@model.coachingConfig}}
                    @planner={{@model.planner}}
                    @onChanged={{this.refresh}}
                  />
                {{/if}}
              {{/let}}
            {{/each}}
          </div>
        {{/if}}
      {{else}}
        <EmptyState @message="Nothing needs your attention." />
      {{/if}}
    </div>
  </template>
}
